module.exports = __webpack_public_path__ + "img/pro1.jpg";